import { Autocomplete } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { Field, Form, Formik } from "formik";
import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { currentTenant, userid } from "../../Common/Credentials.js";
import InventoryService from "../InventoryService.js";
import CategoryServices from "../../Masters/Category/CategoryServices.js";
import Swal from "sweetalert2";
import { salestravels } from "../../Common/Products.js";
import { appmasterid } from "../../Common/Permissions.js";
import { SelectableRadio } from "../../NewUI/NewComponents/SelectableRadio.jsx";
import BrandsServices from "../../Masters/Brands/BrandsServices.js";
import UomServices from "../../Masters/Uom/UomServices.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";

const NewServices = ({ navigate, location }) => {
  const [loader, setLoader] = useState(false);
  const [pagename, setPagename] = useState("");
  const [service, setService] = useState("");
  const [servicecode, setServicecode] = useState("");
  const [servicetax, setServicetax] = useState("");
  const [servicedescription, setServicedescription] = useState("");
  const [CategoryList, setCategoryList] = useState([]);
  const [category, setCategory] = useState("");
  const [catid, setCatid] = useState('');
  const [CategoryList2, setCategoryList2] = useState([]);
  const [category2, setCategory2] = useState("");
  const [catid2, setCatid2] = useState('');
  const [mCategoryList, setMCategoryList] = useState([]);
  const [mcategory, setMcategory] = useState("");
  const [mcatid, setMcategoryid] = useState('');
  const [categorytype, setCategorytype] = useState('');
  const [istravelservice, setIstravelservice] = useState(false);
  const [type, setType] = useState("Other");
  const [hovered, setHovered] = useState(null);

  // Category dialog states
  const [addNewDialogOpen, setAddNewDialogOpen] = useState(false);
  const [addNewDialogOpenSub, setAddNewDialogOpenSub] = useState(false);
  const [addNewDialogOpenLevel3, setAddNewDialogOpenLevel3] = useState(false);
  const [newMainCategory, setNewMainCategory] = useState("");
  const [newSubCategory, setNewSubCategory] = useState("");
  const [newCategoryName, setNewCategoryName] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [addNewMessage, setAddNewMessage] = useState("");
  const [saveLoadingSub, setSaveLoadingSub] = useState(false);
  const [addNewMessageSub, setAddNewMessageSub] = useState("");
  const [saveLoadingLevel3, setSaveLoadingLevel3] = useState(false);
  const [addNewMessageLevel3, setAddNewMessageLevel3] = useState("");

  // Brand & UOM states
  const [brandsList, setBrandsList] = useState([]);
  const [brand, setBrand] = useState("");
  const [brandid, setBrandid] = useState("");
  const [UOMList, setUOMList] = useState([]);
  const [uom, setUom] = useState("");
  const [uomid, setUomid] = useState("");

  // Brand & UOM dialog states
  const [addNewBrandDialogOpen, setAddNewBrandDialogOpen] = useState(false);
  const [addNewUomDialogOpen, setAddNewUomDialogOpen] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");
  const [newUomName, setNewUomName] = useState("");
  const [newUomDescription, setNewUomDescription] = useState("");
  const [addNewMessageBrand, setAddNewMessageBrand] = useState("");
  const [addNewMessageUom, setAddNewMessageUom] = useState("");
  const [saveLoadingBrand, setSaveLoadingBrand] = useState(false);
  const [saveLoadingUom, setSaveLoadingUom] = useState(false);

  // Modern styling - matching NewItem.jsx
  const styles = {
    formGroup: {
      marginBottom: '10px',
    },
    label: {
      display: 'block',
      fontSize: '0.75rem',
      fontWeight: 600,
      color: '#1e293b',
      textTransform: 'uppercase',
      marginBottom: "2px",
      letterSpacing: '0.05em',
    },
    input: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.8rem',
      outline: 'none',
      transition: 'all 0.01s ease',
      backgroundColor: '#ffffff',
      boxSizing: 'border-box',
    },
    inputFocus: {
      borderColor: '#4d4d4d',
      boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.01)',
    },
    inputError: {
      borderColor: '#dc2626',
      boxShadow: '0 0 0 2px rgba(220, 38, 38, 0.01)',
    },
    textarea: {
      width: '100%',
      padding: '8px 12px',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.8rem',
      outline: 'none',
      minHeight: '80px',
      resize: 'vertical',
      backgroundColor: '#ffffff',
      transition: 'all 0.01s ease',
      boxSizing: 'border-box',
    },
    checkbox: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '0.8rem',
      color: '#4d4d4d',
      padding: '8px',
      backgroundColor: '#f8fafc',
      borderRadius: '6px',
      border: '1px solid #e2e8f0',
    },
    checkboxInput: {
      accentColor: '#4d4d4d',
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
    btnPrimary: {
      backgroundColor: '#4d4d4d',
      color: '#ffffff',
    },
    btnOutline: {
      backgroundColor: '#ffffff',
      color: '#4d4d4d',
      border: '1px solid #4d4d4d',
    },
    btnSecondary: {
      backgroundColor: '#f8fafc',
      color: '#374151',
      border: '1px solid #d1d5db',
    },
    btnActions: {
      display: 'flex',
      gap: '8px',
      justifyContent: 'flex-end',
      paddingTop: '16px',
      borderTop: '1px solid #e2e8f0',
      marginTop: '24px',
    },
    helperText: {
      color: '#64748b',
      fontSize: '0.7rem',
      marginTop: '2px',
    },
    switchContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '20px',
      padding: '12px 16px',
      backgroundColor: '#f8fafc',
      borderRadius: '6px',
      border: '1px solid #e2e8f0',
      marginBottom: '16px',
    },
    switchLabel: {
      fontSize: '0.75rem',
      fontWeight: 600,
      color: '#1e293b',
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      lineHeight: 'normal',
      display: 'flex',
      alignItems: 'center',
    },
    radioGroup: {
      display: 'flex',
      gap: '16px',
      alignItems: 'center',
    },
    radioOption: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      fontSize: '0.8rem',
      color: '#374151',
      cursor: 'pointer',
      verticalAlign: 'middle',
      margin: 0,
      padding: 0,
      lineHeight: "1",
      alignItems: "center",
    },
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    },
    spinner: {
      width: '40px',
      height: '40px',
      border: '4px solid #e2e8f0',
      borderTop: '4px solid #4d4d4d',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
  };

  useEffect(() => {
    if (userid === undefined) {
      Swal.fire({
        title: "Session Expired",
        text: "Your Session is Lost: Please login Back to resume",
        icon: "warning",
        confirmButtonText: "Ok",
        confirmButtonColor: "#4d4d4d",
      }).then(() => navigate('/'));
      return;
    }

    const { pagename } = location.state;
    setPagename(pagename);

    CategoryServices.getMainCategory(currentTenant)
      .then((response) => {
        setMCategoryList(response.data.filter((e) => e.categorytype === "Service"));
      })
      .catch((e) => {
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: "Session Expired",
            text: "Your Session is Lost: Please login Back to resume",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#4d4d4d",
          }).then(() => navigate('/'));
        }
      });

    UomServices.getUOM(currentTenant)
      .then((response) => {
        const uniqueUom = [];
        const seen = new Set();
        (response.data || []).forEach(u => {
          if (u.id && !seen.has(u.id)) {
            seen.add(u.id);
            uniqueUom.push(u);
          }
        });
        setUOMList(uniqueUom);
      });

    BrandsServices.getBrands(currentTenant)
      .then((response) => {
        const uniqueBrands = [];
        const seen = new Set();
        (response.data || []).forEach(b => {
          if (b.id && !seen.has(b.id)) {
            seen.add(b.id);
            uniqueBrands.push(b);
          }
        });
        setBrandsList(uniqueBrands);
      });
  }, [navigate, location]);

  const onSubmit = (values) => {
    setLoader(true);
    let servicedata = {
      catid: catid === "" || catid === undefined ? 0 : catid,
      category: category,
      categorylvl2: category2,
      mcategory: mcategory,
      catidlvl2: catid2 === "" || catid2 === undefined ? 0 : catid2,
      mcatid: mcatid,
      service: service,
      servicecode: servicecode,
      servicetax: parseFloat(servicetax) || 0, // Make tax optional
      servicedescription: servicedescription,
      createdby: userid,
      tenantid: currentTenant,
      istravelservice: istravelservice,
      type: type,
      brandid: brandid || 0,
      brand: brand,
      uomid: uomid || 0,
      uom: uom
    };

    InventoryService.addService(servicedata)
      .then((response) => {
        setLoader(false);
        Swal.fire({
          title: `Service added successfully`,
          text: ".",
          icon: "success",
          confirmButtonText: "Ok",
          confirmButtonColor: "#4d4d4d",
        }).then(() => navigate({ pathname: `/services` }, { state: { message: response.data } }));
      })
      .catch((e) => {
        const message = e.response?.data?.message === undefined ? e.response?.data : e.response?.data?.message;
        setLoader(false);
        if (e.response?.data?.error === "Unauthorized") {
          Swal.fire({
            title: `Your Session is Lost: Please login Back to resume`,
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#4d4d4d",
          }).then(() => navigate('/'));
        } else {
          Swal.fire({
            title: `${message}`,
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#4d4d4d",
          });
        }
      });
  };

  const handleCategory = (event, newValue) => {
    if (newValue && typeof newValue === 'object' && newValue !== null) {
      if (newValue.inputValue === 'add-new') {
        handleAddNewCategory();
      } else {
        let data = mCategoryList.find(e => e.id === newValue.id).categorylvltwo;
        setMcategoryid(newValue.id);
        setMcategory(newValue.category);
        setCategorytype(newValue.categorytype);
        setCategoryList2(data);
        setCatid2('');
        setCategory2('');
        setCatid('');
        setCategory('');
        setCategoryList([]);
      }
    }
  };

  const handleCategory2 = (event, newValue) => {
    if (newValue && typeof newValue === 'object' && newValue !== null) {
      if (newValue.inputValue === 'add-new') {
        handleAddNewSubCategory();
      } else {
        let data = CategoryList2.find(e => e.id === newValue.id).category;
        setCatid2(newValue.id);
        setCategory2(newValue.name);
        setCategoryList(data);
        setCatid('');
        setCategory('');
      }
    } else {
      setCatid2('');
      setCategory2('');
      setCatid('');
      setCategory('');
      setCategoryList([]);
    }
  };

  const handleCategory3 = (event, newValue) => {
    if (newValue && typeof newValue === 'object' && newValue !== null) {
      if (newValue.inputValue === 'add-new') {
        handleAddNewCategoryLevel3();
      } else {
        setCatid(newValue.id);
        setCategory(newValue.category);
      }
    } else {
      setCatid('');
      setCategory('');
    }
  };

  const onfocus = () => {
    const taxInput = document.getElementById('tax');
    if (taxInput) {
      taxInput.addEventListener('mousewheel', function (event) {
        if (window.document.activeElement.type === 'number') {
          event.preventDefault();
        }
      });
      taxInput.addEventListener('keydown', function (e) {
        if (e.which === 38 || e.which === 40) {
          e.preventDefault();
        }
      });
    }
  };

  const validate = (values) => {
    let errors = {};
    if (!mcategory || mcategory === "") {
      errors.mcategory = "Category is required";
    }
    if (!service || service === "") {
      errors.service = "Service is required";
    }
    // Remove servicecode validation to make HSN/SAC optional
    // Remove servicetax validation to make it optional
    if (!servicedescription || servicedescription === "") {
      errors.servicedescription = "Service Description is required";
    }

    if (CategoryList2.length !== 0) {
      if (category2 === "") {
        errors.category2 = "Category level 2 is required";
      }
    }

    if (CategoryList.length !== 0) {
      if (category === "") {
        errors.category = "Category level 3 is required";
      }
    }

    return errors;
  };

  // Category Dialog Handlers
  const handleAddNewCategory = () => {
    setAddNewDialogOpen(true);
    setNewMainCategory("");
    setNewSubCategory("");
    setNewCategoryName("");
    setAddNewMessage("");
    setSaveLoading(false);
  };

  const handleAddNewSubCategory = () => {
    if (!mcatid) {
      Swal.fire({
        title: "Select Main Category First",
        text: "Please select a main category before adding a sub category",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }
    setAddNewDialogOpenSub(true);
    setNewSubCategory("");
    setNewCategoryName("");
    setAddNewMessageSub("");
    setSaveLoadingSub(false);
  };

  const handleAddNewCategoryLevel3 = () => {
    if (!catid2) {
      Swal.fire({
        title: "Select Sub Category First",
        text: "Please select a sub category before adding a category level 3",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }
    setAddNewDialogOpenLevel3(true);
    setNewCategoryName("");
    setAddNewMessageLevel3("");
    setSaveLoadingLevel3(false);
  };

  const submitNewCategory = () => {
    if (!newMainCategory || newMainCategory.trim() === "") {
      setAddNewMessage("Main Category is required");
      return;
    }

    setSaveLoading(true);

    let mainId, subId, level3Id;

    // Step 1: Create main category only
    CategoryServices.addMainCategory({
      category: newMainCategory,
      tenantid: currentTenant,
      categorytype: 1, // Service category
    })
      .then((res) => {
        mainId = res.data;

        // Step 2: If sub category provided, create it
        if (newSubCategory && newSubCategory.trim() !== "") {
          return CategoryServices.addCategorylvl2({
            name: newSubCategory,
            category: mainId,
            tenantid: currentTenant,
          });
        }
        return { data: null };
      })
      .then((res) => {
        if (res && res.data) {
          subId = res.data;
          // Step 3: If category level 3 provided, create it
          if (newCategoryName && newCategoryName.trim() !== "") {
            return CategoryServices.addCategory({
              category: newCategoryName,
              catid: subId,
              categorytype: 1,
              tenantid: currentTenant,
            });
          }
        }
        return { data: null };
      })
      .then((res) => {
        if (res && res.data) {
          level3Id = res.data;
        }
        // Refresh the main categories list
        return CategoryServices.getMainCategory(currentTenant);
      })
      .then((response) => {
        const updatedCategories = response.data.filter(e => e.categorytype === "Service");
        const newCategory = updatedCategories.find(cat => cat.category === newMainCategory);

        if (newCategory) {
          setMCategoryList(updatedCategories);
          setMcategoryid(newCategory.id);
          setMcategory(newCategory.category);
          setCategorytype(newCategory.categorytype);

          // Auto-select sub category if created
          if (subId) {
            const newSubCategoryObj = newCategory.categorylvltwo.find(sub => sub.id === subId);
            if (newSubCategoryObj) {
              setCategoryList2(newCategory.categorylvltwo || []);
              setCatid2(subId);
              setCategory2(newSubCategory);

              // Auto-select category level 3 if created
              if (level3Id) {
                const newLevel3Category = newSubCategoryObj.category.find(level3 => level3.category === newCategoryName);
                if (newLevel3Category) {
                  setCategoryList(newSubCategoryObj.category || []);
                  setCatid(level3Id);
                  setCategory(newCategoryName);
                } else {
                  setCategoryList([]);
                  setCatid('');
                  setCategory('');
                }
              } else {
                setCategoryList([]);
                setCatid('');
                setCategory('');
              }
            } else {
              setCategoryList2([]);
              setCatid2('');
              setCategory2('');
              setCategoryList([]);
              setCatid('');
              setCategory('');
            }
          } else {
            setCategoryList2([]);
            setCatid2('');
            setCategory2('');
            setCategoryList([]);
            setCatid('');
            setCategory('');
          }

          setAddNewDialogOpen(false);
          setSaveLoading(false);
          setNewMainCategory("");
          setNewSubCategory("");
          setNewCategoryName("");
        }
      })
      .catch((e) => {
        const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
        setAddNewMessage(msg);
        setSaveLoading(false);
      });
  };

  const submitNewSubCategory = () => {
    if (!newSubCategory || newSubCategory.trim() === "") {
      setAddNewMessageSub("Sub Category is required");
      return;
    }

    setSaveLoadingSub(true);

    let subId, level3Id;

    // Create sub category
    CategoryServices.addCategorylvl2({
      name: newSubCategory,
      category: mcatid,
      tenantid: currentTenant,
    })
      .then((res) => {
        subId = res.data;

        // If category level 3 provided, create it
        if (newCategoryName && newCategoryName.trim() !== "") {
          return CategoryServices.addCategory({
            category: newCategoryName,
            catid: subId,
            categorytype: 1,
            tenantid: currentTenant,
          });
        }
        return { data: null };
      })
      .then((res) => {
        if (res && res.data) {
          level3Id = res.data;
        }
        // Refresh the main category to get updated sub categories
        return CategoryServices.getMainCategoryById(mcatid);
      })
      .then((response) => {
        const updatedMainCategory = response.data;

        // Update the main category in the list
        const updatedMCategoryList = mCategoryList.map(cat =>
          cat.id === mcatid ? updatedMainCategory : cat
        );

        setMCategoryList(updatedMCategoryList);
        setCategoryList2(updatedMainCategory.categorylvltwo || []);
        setCatid2(subId);
        setCategory2(newSubCategory);

        // Auto-select category level 3 if created
        if (level3Id) {
          const newSubCategoryObj = updatedMainCategory.categorylvltwo.find(sub => sub.id === subId);
          if (newSubCategoryObj) {
            setCategoryList(newSubCategoryObj.category || []);
            setCatid(level3Id);
            setCategory(newCategoryName);
          } else {
            setCategoryList([]);
            setCatid('');
            setCategory('');
          }
        } else {
          setCategoryList([]);
          setCatid('');
          setCategory('');
        }

        setAddNewDialogOpenSub(false);
        setSaveLoadingSub(false);
        setNewSubCategory("");
        setNewCategoryName("");
      })
      .catch((e) => {
        const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
        setAddNewMessageSub(msg);
        setSaveLoadingSub(false);
      });
  };

  const submitNewCategoryLevel3 = () => {
    if (!newCategoryName || newCategoryName.trim() === "") {
      setAddNewMessageLevel3("Category Level 3 is required");
      return;
    }

    setSaveLoadingLevel3(true);

    let level3Id;

    // Create category level 3
    CategoryServices.addCategory({
      category: newCategoryName,
      catid: catid2,
      categorytype: 1,
      tenantid: currentTenant,
    })
      .then((res) => {
        level3Id = res.data;
        // Refresh the sub category to get updated categories
        return CategoryServices.getCategorylvl2ById(catid2);
      })
      .then((response) => {
        const updatedSubCategory = response.data;

        // Update the sub category in CategoryList2 and mCategoryList
        const updatedCategoryList2 = CategoryList2.map(subCat =>
          subCat.id === catid2 ? updatedSubCategory : subCat
        );

        const updatedMCategoryList = mCategoryList.map(mainCat => ({
          ...mainCat,
          categorylvltwo: mainCat.categorylvltwo.map(subCat =>
            subCat.id === catid2 ? updatedSubCategory : subCat
          )
        }));

        setCategoryList2(updatedCategoryList2);
        setMCategoryList(updatedMCategoryList);
        setCategoryList(updatedSubCategory.category || []);
        setCatid(level3Id);
        setCategory(newCategoryName);
        setAddNewDialogOpenLevel3(false);
        setSaveLoadingLevel3(false);
        setNewCategoryName("");
      })
      .catch((e) => {
        const msg = (e.response && e.response.data && e.response.data.message) || "Server error";
        setAddNewMessageLevel3(msg);
        setSaveLoadingLevel3(false);
      });
  };

  const handleBrand = (event, newValue) => {
    if (newValue && typeof newValue === 'object' && newValue !== null) {
      if (newValue.inputValue === 'add-new') {
        handleAddNewBrand();
      } else {
        setBrandid(newValue.id);
        setBrand(newValue.brand);
      }
    } else {
      setBrandid('');
      setBrand('');
    }
  };

  const handleUom = (event, newValue) => {
    if (newValue && typeof newValue === 'object' && newValue !== null) {
      if (newValue.inputValue === 'add-new') {
        handleAddNewUom();
      } else {
        setUomid(newValue.id);
        setUom(newValue.name);
      }
    } else {
      setUomid('');
      setUom('');
    }
  };

  const handleAddNewBrand = () => {
    setAddNewBrandDialogOpen(true);
    setNewBrandName("");
    setAddNewMessageBrand("");
    setSaveLoadingBrand(false);
  };

  const handleAddNewUom = () => {
    setAddNewUomDialogOpen(true);
    setNewUomName("");
    setNewUomDescription("");
    setAddNewMessageUom("");
    setSaveLoadingUom(false);
  };

  const submitNewBrand = () => {
    if (!newBrandName || newBrandName.trim() === "") {
      setAddNewMessageBrand("Brand Name is required");
      return;
    }

    setSaveLoadingBrand(true);

    // Client-side existence check
    const existingBrand = brandsList.find(b => (b.brand || '').toLowerCase() === newBrandName.trim().toLowerCase());
    if (existingBrand) {
      setBrandid(existingBrand.id);
      setBrand(existingBrand.brand);
      setAddNewBrandDialogOpen(false);
      setSaveLoadingBrand(false);
      setNewBrandName("");
      Swal.fire({
        title: "Brand Exists",
        text: "This brand already exists. Selected the existing one.",
        icon: "info",
        confirmButtonColor: "#4d4d4d",
      });
      return;
    }

    BrandsServices.addBrand({
      name: newBrandName,
      tenantid: currentTenant
    })
      .then(() => {
        // Re-fetch the full list (just like Category flow does)
        return BrandsServices.getBrands(currentTenant);
      })
      .then((response) => {
        const freshList = response.data || [];
        // Deduplicate
        const uniqueBrands = [];
        const seen = new Set();
        freshList.forEach(b => {
          if (!seen.has(b.id)) {
            seen.add(b.id);
            uniqueBrands.push(b);
          }
        });

        // Find the newly created brand in the refreshed list — matching Category pattern
        const createdBrand = uniqueBrands.find(b =>
          (b.brand || '').toLowerCase() === newBrandName.trim().toLowerCase()
        );

        setBrandsList(uniqueBrands);
        if (createdBrand) {
          setBrandid(createdBrand.id);
          setBrand(createdBrand.brand);
        }
        setAddNewBrandDialogOpen(false);
        setSaveLoadingBrand(false);
        setNewBrandName("");
        Swal.fire({
          title: "Brand Added",
          text: "New brand created and selected successfully.",
          icon: "success",
          confirmButtonColor: "#4d4d4d",
        });
      })
      .catch((e) => {
        const msg = (e.response && e.response.data && e.response.data.message) || "Error adding brand";
        setAddNewMessageBrand(msg);
        setSaveLoadingBrand(false);
      });
  };

  const submitNewUom = () => {
    if (!newUomName || newUomName.trim() === "") {
      setAddNewMessageUom("UOM Name is required");
      return;
    }

    setSaveLoadingUom(true);

    // Client-side existence check
    const existingUom = UOMList.find(u => (u.name || '').toLowerCase() === newUomName.trim().toLowerCase());
    if (existingUom) {
      setUomid(existingUom.id);
      setUom(existingUom.name);
      setAddNewUomDialogOpen(false);
      setSaveLoadingUom(false);
      setNewUomName("");
      setNewUomDescription("");
      Swal.fire({
        title: "UOM Exists",
        text: "This UOM already exists. Selected the existing one.",
        icon: "info",
        confirmButtonColor: "#4d4d4d",
      });
      return;
    }

    UomServices.adduom({
      name: newUomName,
      description: newUomDescription,
      tenantid: currentTenant
    })
      .then(() => {
        // Re-fetch the full list (just like Category flow does)
        return UomServices.getUOM(currentTenant);
      })
      .then((response) => {
        const freshList = response.data || [];
        // Deduplicate
        const uniqueUom = [];
        const seen = new Set();
        freshList.forEach(u => {
          if (!seen.has(u.id)) {
            seen.add(u.id);
            uniqueUom.push(u);
          }
        });

        // Find the newly created UOM in the refreshed list — matching Category pattern
        const createdUom = uniqueUom.find(u =>
          (u.name || '').toLowerCase() === newUomName.trim().toLowerCase()
        );

        setUOMList(uniqueUom);
        if (createdUom) {
          setUomid(createdUom.id);
          setUom(createdUom.name);
        }
        setAddNewUomDialogOpen(false);
        setSaveLoadingUom(false);
        setNewUomName("");
        setNewUomDescription("");
        Swal.fire({
          title: "UOM Added",
          text: "New UOM created and selected successfully.",
          icon: "success",
          confirmButtonColor: "#4d4d4d",
        });
      })
      .catch((e) => {
        const msg = (e.response && e.response.data && e.response.data.message) || "Error adding UOM";
        setAddNewMessageUom(msg);
        setSaveLoadingUom(false);
      });
  };

  return (
    <div className="UI-container">
      {/* Loading Overlay */}
      {loader && (
        <div style={styles.loadingOverlay}>
          <div style={styles.spinner}></div>
        </div>
      )}

      <div className="UI-card">
        <div className="UI-header">
        <Breadcrumb breadcrumbs={[{name:"Home",path:"/inventory"},{name:"Services",path:"/services"},{name:pagename,path:null}]}/>

          <div className="UI-header-content">
            <div>
              <h1 className="UI-title">{pagename}</h1>
              <p className="UI-subtitle">
                {pagename === 'New Service' ? 'Create a new service' : 'Modify existing service details'}
              </p>
            </div>
            <div className="UI-header-actions">
              <Link
                to="/services"
                style={{
                  backgroundColor: hovered === "back" ? "#4d4d4d" : '#ffffff',
                  color: hovered === "back" ? "#fff" : "#4d4d4d",
                  transform: hovered === "back" ? "scale(1.02)" : "scale(1)",
                  transition: "all 0.01s ease",
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  border: '1px solid #4d4d4d',
                  fontSize: '0.8rem',
                  fontWeight: 500,
                  cursor: 'pointer',
                  textDecoration: 'none',
                  minHeight: '32px',
                }}
                onMouseEnter={() => setHovered("back")}
                onMouseLeave={() => setHovered(null)}
              >
                ← Back
              </Link>
            </div>
          </div>
        </div>

        <div className="UI-form-container" style={{ paddingTop: 0 }}>
          <Formik
            initialValues={{
              categorytype,
              category,
              catid,
              category2,
              catid2,
              mcategory,
              mcatid,
              CategoryList,
              CategoryList2,
              mCategoryList,
              service,
              servicecode,
              servicetax,
              servicedescription,
              brandid,
              uomid,
            }}
            onSubmit={onSubmit}
            validate={validate}
            enableReinitialize={true}
          >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
              <Form onSubmit={handleSubmit}>
                {/* Travel Service Section */}
                {salestravels === "YES" && (
                  <div className="UI-form-section">
                    <div className="UI-form-grid">
                      <div style={{ ...styles.formGroup, marginTop: '20px' }}>
                        <label style={styles.checkbox} onClick={() => setIstravelservice(!istravelservice)}>
                          <SelectableRadio
                            checked={istravelservice}
                            size="md"
                          />
                          Is Travel Service?
                        </label>
                      </div>

                      {istravelservice && (
                        <div style={styles.formGroup}>
                          <label style={styles.label}>Service Type</label>
                          <Autocomplete
                            options={["Ticket", "Hotel", "Other"]}
                            getOptionLabel={(option) => option || ""}
                            value={type || null}
                            onChange={(event, newValue) => setType(newValue)}
                            renderInput={(params) => (
                              <div ref={params.InputProps.ref}>
                                <input
                                  type="text"
                                  {...params.inputProps}
                                  style={{
                                    ...styles.input,
                                    ...(errors?.type ? styles.inputError : {})
                                  }}
                                  placeholder="Select service type"
                                />
                              </div>
                            )}
                          />
                          {errors?.type && (
                            <div className="UI-error-text">{errors.type}</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Category Information */}
                <div className="UI-form-section">
                  <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Category Information</h3>
                  <div className="UI-form-grid">
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Main Category *</label>
                      <Autocomplete
                        options={mCategoryList}
                        getOptionLabel={(option) => option.category || ''}
                        value={mCategoryList.find(cat => cat.id === mcatid) || null}
                        onChange={handleCategory}
                        filterOptions={(options, params) => {
                          const filtered = options.filter(opt =>
                            opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                          );
                          if (appmasterid === "2" || appmasterid === "3") {
                            filtered.unshift({
                              inputValue: 'add-new',
                              category: '+ Add New Category',
                            });
                          }
                          return filtered;
                        }}
                        renderOption={(props, option) => {
                          const isAddNew = option.inputValue === 'add-new';
                          return (
                            <li
                              {...props}
                              style={{
                                fontWeight: isAddNew ? 'bold' : 'normal',
                                color: isAddNew ? '#4d4d4d' : 'inherit',
                                transition: 'transform 0.01s ease',
                              }}
                              onMouseEnter={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                              }}
                              onMouseLeave={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              {option.category}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <div ref={params.InputProps.ref}>
                            <input
                              type="text"
                              {...params.inputProps}
                              style={{
                                ...styles.input,
                                ...(errors.mcategory ? styles.inputError : {}),
                              }}
                              placeholder="Select main category"
                            />
                          </div>
                        )}
                      />
                      {errors.mcategory && (
                        <div className="UI-error-text">{errors.mcategory}</div>
                      )}
                    </div>

                    {/* Always show Sub Category if main category is selected */}
                    {mcatid && (
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Sub Category {CategoryList2.length > 0 ? '*' : ''}</label>
                        <Autocomplete
                          options={CategoryList2}
                          getOptionLabel={(option) => option.name || ''}
                          value={CategoryList2.find(cat => cat.id === catid2) || null}
                          onChange={handleCategory2}
                          filterOptions={(options, params) => {
                            const filtered = options.filter(opt =>
                              opt.name.toLowerCase().includes(params.inputValue.toLowerCase())
                            );
                            if (appmasterid === "2" || appmasterid === "3") {
                              filtered.unshift({
                                inputValue: 'add-new',
                                name: '+ Add New Sub Category',
                              });
                            }
                            return filtered;
                          }}
                          renderOption={(props, option) => {
                            const isAddNew = option.inputValue === 'add-new';
                            return (
                              <li
                                {...props}
                                style={{
                                  fontWeight: isAddNew ? 'bold' : 'normal',
                                  color: isAddNew ? '#4d4d4d' : 'inherit',
                                  transition: 'transform 0.01s ease',
                                }}
                                onMouseEnter={(e) => {
                                  if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                }}
                                onMouseLeave={(e) => {
                                  if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                type="text"
                                {...params.inputProps}
                                style={{
                                  ...styles.input,
                                  ...(errors.category2 ? styles.inputError : {})
                                }}
                                placeholder={CategoryList2.length > 0 ? "Select sub category" : "No sub categories - click to add new"}
                              />
                            </div>
                          )}
                        />
                        {errors.category2 && (
                          <div className="UI-error-text">{errors.category2}</div>
                        )}
                      </div>
                    )}

                    {/* Always show Category Level 3 if sub category is selected */}
                    {catid2 && (
                      <div style={styles.formGroup}>
                        <label style={styles.label}>Category Level 3 {CategoryList.length > 0 ? '*' : ''}</label>
                        <Autocomplete
                          options={CategoryList}
                          getOptionLabel={(option) => option.category || ''}
                          value={CategoryList.find(cat => cat.id === catid) || null}
                          onChange={handleCategory3}
                          filterOptions={(options, params) => {
                            const filtered = options.filter(opt =>
                              opt.category.toLowerCase().includes(params.inputValue.toLowerCase())
                            );
                            if (appmasterid === "2" || appmasterid === "3") {
                              filtered.unshift({
                                inputValue: 'add-new',
                                category: '+ Add New Category Level 3',
                              });
                            }
                            return filtered;
                          }}
                          renderOption={(props, option) => {
                            const isAddNew = option.inputValue === 'add-new';
                            return (
                              <li
                                {...props}
                                style={{
                                  fontWeight: isAddNew ? 'bold' : 'normal',
                                  color: isAddNew ? '#4d4d4d' : 'inherit',
                                  transition: 'transform 0.01s ease',
                                }}
                                onMouseEnter={(e) => {
                                  if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                                }}
                                onMouseLeave={(e) => {
                                  if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                                }}
                              >
                                {option.category}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref}>
                              <input
                                type="text"
                                {...params.inputProps}
                                style={{
                                  ...styles.input,
                                  ...(errors.category ? styles.inputError : {})
                                }}
                                placeholder={CategoryList.length > 0 ? "Select category level 3" : "No categories - click to add new"}
                              />
                            </div>
                          )}
                        />
                        {errors.category && (
                          <div className="UI-error-text">{errors.category}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Service Information */}
                <div className="UI-form-section">
                  <h3 className="UI-section-title" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: '6px' }}>Service Information</h3>
                  <div className="UI-form-grid">
                    <div style={styles.formGroup}>
                      <label style={styles.label}>Service Name *</label>
                      <input
                        type="text"
                        name="service"
                        value={service}
                        onChange={(e) => setService(e.target.value)}
                        style={{
                          ...styles.input,
                          ...(errors.service ? styles.inputError : {})
                        }}
                        placeholder="Enter service name"
                      />
                      {errors.service && (
                        <div className="UI-error-text">{errors.service}</div>
                      )}
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>HSN/SAC Code</label>
                      <input
                        type="text"
                        name="servicecode"
                        value={servicecode}
                        onChange={(e) => setServicecode(e.target.value)}
                        style={{
                          ...styles.input,
                        }}
                        placeholder="Enter HSN/SAC code (optional)"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Service Tax (%)</label>
                      <input
                        id="tax"
                        type="number"
                        name="servicetax"
                        value={servicetax}
                        onChange={(e) => setServicetax(e.target.value)}
                        style={{
                          ...styles.input,
                        }}
                        onFocus={onfocus}
                        placeholder="0.00 (optional)"
                        min="0"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Brand</label>
                      <Autocomplete
                        options={brandsList}
                        getOptionLabel={(option) => option.brand || ''}
                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                        value={brandid ? (brandsList.find(b => String(b.id) === String(brandid)) || null) : null}
                        onChange={handleBrand}
                        filterOptions={(options, params) => {
                          const filtered = options.filter(opt =>
                            (opt.brand || '').toLowerCase().includes((params.inputValue || '').toLowerCase())
                          );
                          if (appmasterid === "2" || appmasterid === "3") {
                            filtered.unshift({
                              inputValue: 'add-new',
                              brand: '+ Add New Brand',
                            });
                          }
                          return filtered;
                        }}
                        renderOption={(props, option) => {
                          const isAddNew = option.inputValue === 'add-new';
                          return (
                            <li
                              {...props}
                              style={{
                                fontWeight: isAddNew ? 'bold' : 'normal',
                                color: isAddNew ? '#4d4d4d' : 'inherit',
                                transition: 'transform 0.01s ease',
                              }}
                              onMouseEnter={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                              }}
                              onMouseLeave={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              {option.brand}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <div ref={params.InputProps.ref}>
                            <input
                              type="text"
                              {...params.inputProps}
                              style={styles.input}
                              placeholder="Select brand (optional)"
                            />
                          </div>
                        )}
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>UOM</label>
                      <Autocomplete
                        options={UOMList}
                        getOptionLabel={(option) => option.name || ''}
                        isOptionEqualToValue={(option, value) => String(option.id) === String(value?.id)}
                        value={uomid ? (UOMList.find(u => String(u.id) === String(uomid)) || null) : null}
                        onChange={handleUom}
                        filterOptions={(options, params) => {
                          const filtered = options.filter(opt =>
                            (opt.name || '').toLowerCase().includes((params.inputValue || '').toLowerCase())
                          );
                          if (appmasterid === "2" || appmasterid === "3") {
                            filtered.unshift({
                              inputValue: 'add-new',
                              name: '+ Add New UOM',
                            });
                          }
                          return filtered;
                        }}
                        renderOption={(props, option) => {
                          const isAddNew = option.inputValue === 'add-new';
                          return (
                            <li
                              {...props}
                              style={{
                                fontWeight: isAddNew ? 'bold' : 'normal',
                                color: isAddNew ? '#4d4d4d' : 'inherit',
                                transition: 'transform 0.01s ease',
                              }}
                              onMouseEnter={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1.02)';
                              }}
                              onMouseLeave={(e) => {
                                if (isAddNew) e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              {option.name}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <div ref={params.InputProps.ref}>
                            <input
                              type="text"
                              {...params.inputProps}
                              style={styles.input}
                              placeholder="Select UOM (optional)"
                            />
                          </div>
                        )}
                      />
                    </div>
                  </div>

                  <div style={styles.formGroup}>
                    <label style={styles.label}>Service Description *</label>
                    <textarea
                      name="servicedescription"
                      value={servicedescription}
                      onChange={(e) => setServicedescription(e.target.value)}
                      style={{
                        ...styles.textarea,
                        ...(errors.servicedescription ? styles.inputError : {})
                      }}
                      placeholder="Enter detailed service description"
                    />
                    {errors.servicedescription && (
                      <div className="UI-error-text">{errors.servicedescription}</div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div style={styles.btnActions}>
                  <Link
                    to="/services"
                    style={{
                      backgroundColor: hovered === "cancel" ? "#4d4d4d" : '#ffffff',
                      color: hovered === "cancel" ? "#fff" : "#4d4d4d",
                      transform: hovered === "cancel" ? "scale(1.03)" : "scale(1)",
                      transition: "all 0.01s ease",
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: '1px solid #4d4d4d',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      cursor: 'pointer',
                      textDecoration: 'none',
                      minHeight: '32px',
                    }}
                    onMouseEnter={() => setHovered("cancel")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    disabled={isSubmitting || loader}
                    style={{
                      backgroundColor: '#4d4d4d',
                      color: '#ffffff',
                      opacity: (isSubmitting || loader) ? 0.6 : 1,
                      transform: hovered === "submit" ? "scale(1.07)" : "scale(1)",
                      transition: "all 0.01s ease",
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '6px 12px',
                      borderRadius: '6px',
                      border: 'none',
                      fontSize: '0.8rem',
                      fontWeight: 500,
                      cursor: 'pointer',
                      minHeight: '32px',
                    }}
                    onMouseEnter={() => setHovered("submit")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    {loader ? 'Saving...' : 'Save Service'}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      {/* Add New Main Category Dialog */}
      <Dialog
        open={addNewDialogOpen}
        onClose={() => setAddNewDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: 0,
            backgroundColor: '#ffffff',
          },
        }}
      >
        <DialogTitle className="UI-title">
          Add New Service Category
        </DialogTitle>

        <DialogContent style={{ paddingTop: 0 }}>
          <div className="UI-form-section">
            <div style={styles.formGroup}>
              <label style={styles.label}>Main Category *</label>
              <input
                type="text"
                value={newMainCategory}
                onChange={(e) => {
                  setNewMainCategory(e.target.value);
                  setAddNewMessage("");
                }}
                style={{
                  ...styles.input,
                  ...(addNewMessage ? styles.inputError : {}),
                }}
                placeholder="Enter main category"
                autoFocus
              />
              {addNewMessage && (
                <div className="UI-error-text">{addNewMessage}</div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Sub Category (optional)</label>
              <input
                type="text"
                value={newSubCategory}
                onChange={(e) => {
                  setNewSubCategory(e.target.value);
                  setAddNewMessage("");
                }}
                style={styles.input}
                placeholder="Enter sub category"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Category Level 3 (optional)</label>
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => {
                  setNewCategoryName(e.target.value);
                  setAddNewMessage("");
                }}
                style={styles.input}
                placeholder="Enter category level 3"
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setAddNewDialogOpen(false)}
            disabled={saveLoading}
            style={{
              backgroundColor: hovered === "dialogCancel" ? "#4d4d4d" : '#ffffff',
              color: hovered === "dialogCancel" ? "#fff" : "#4d4d4d",
              transform: hovered === "dialogCancel" ? "scale(1.03)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #4d4d4d',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogCancel")}
            onMouseLeave={() => setHovered(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={submitNewCategory}
            disabled={saveLoading || !(newMainCategory && newMainCategory.trim())}
            variant="contained"
            style={{
              backgroundColor: '#4d4d4d',
              color: '#ffffff',
              opacity: saveLoading ? 0.6 : 1,
              transform: hovered === "dialogSave" ? "scale(1.07)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogSave")}
            onMouseLeave={() => setHovered(null)}
          >
            {saveLoading ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New Sub Category Dialog */}
      <Dialog
        open={addNewDialogOpenSub}
        onClose={() => setAddNewDialogOpenSub(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: 0,
            backgroundColor: '#ffffff',
          },
        }}
      >
        <DialogTitle className="UI-title">
          Add New Sub Category
        </DialogTitle>

        <DialogContent style={{ paddingTop: 0 }}>
          <div className="UI-form-section">
            <div style={styles.formGroup}>
              <label style={styles.label}>Main Category</label>
              <input
                type="text"
                value={mcategory}
                style={{
                  ...styles.input,
                  backgroundColor: '#f8fafc',
                  color: '#64748b',
                  cursor: 'not-allowed',
                }}
                disabled
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Sub Category *</label>
              <input
                type="text"
                value={newSubCategory}
                onChange={(e) => {
                  setNewSubCategory(e.target.value);
                  setAddNewMessageSub("");
                }}
                style={{
                  ...styles.input,
                  ...(addNewMessageSub ? styles.inputError : {}),
                }}
                placeholder="Enter sub category"
                autoFocus
              />
              {addNewMessageSub && (
                <div className="UI-error-text">{addNewMessageSub}</div>
              )}
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Category Level 3 (optional)</label>
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => {
                  setNewCategoryName(e.target.value);
                  setAddNewMessageSub("");
                }}
                style={styles.input}
                placeholder="Enter category level 3"
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setAddNewDialogOpenSub(false)}
            disabled={saveLoadingSub}
            style={{
              backgroundColor: hovered === "dialogSubCancel" ? "#4d4d4d" : '#ffffff',
              color: hovered === "dialogSubCancel" ? "#fff" : "#4d4d4d",
              transform: hovered === "dialogSubCancel" ? "scale(1.03)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #4d4d4d',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogSubCancel")}
            onMouseLeave={() => setHovered(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={submitNewSubCategory}
            disabled={saveLoadingSub || !(newSubCategory && newSubCategory.trim())}
            style={{
              backgroundColor: '#4d4d4d',
              color: '#ffffff',
              opacity: saveLoadingSub ? 0.6 : 1,
              transform: hovered === "dialogSubSave" ? "scale(1.07)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogSubSave")}
            onMouseLeave={() => setHovered(null)}
          >
            {saveLoadingSub ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New Category Level 3 Dialog */}
      <Dialog
        open={addNewDialogOpenLevel3}
        onClose={() => setAddNewDialogOpenLevel3(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: 0,
            backgroundColor: '#ffffff',
          },
        }}
      >
        <DialogTitle className="UI-title">
          Add New Category Level 3
        </DialogTitle>

        <DialogContent style={{ paddingTop: 0 }}>
          <div className="UI-form-section">
            <div style={styles.formGroup}>
              <label style={styles.label}>Main Category</label>
              <input
                type="text"
                value={mcategory}
                style={{
                  ...styles.input,
                  backgroundColor: '#f8fafc',
                  color: '#64748b',
                  cursor: 'not-allowed',
                }}
                disabled
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Sub Category</label>
              <input
                type="text"
                value={category2}
                style={{
                  ...styles.input,
                  backgroundColor: '#f8fafc',
                  color: '#64748b',
                  cursor: 'not-allowed',
                }}
                disabled
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Category Level 3 *</label>
              <input
                type="text"
                value={newCategoryName}
                onChange={(e) => {
                  setNewCategoryName(e.target.value);
                  setAddNewMessageLevel3("");
                }}
                style={{
                  ...styles.input,
                  ...(addNewMessageLevel3 ? styles.inputError : {}),
                }}
                placeholder="Enter category level 3"
                autoFocus
              />
              {addNewMessageLevel3 && (
                <div className="UI-error-text">{addNewMessageLevel3}</div>
              )}
            </div>
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setAddNewDialogOpenLevel3(false)}
            disabled={saveLoadingLevel3}
            style={{
              backgroundColor: hovered === "dialogLevel3Cancel" ? "#4d4d4d" : '#ffffff',
              color: hovered === "dialogLevel3Cancel" ? "#fff" : "#4d4d4d",
              transform: hovered === "dialogLevel3Cancel" ? "scale(1.03)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #4d4d4d',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogLevel3Cancel")}
            onMouseLeave={() => setHovered(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={submitNewCategoryLevel3}
            disabled={saveLoadingLevel3 || !(newCategoryName && newCategoryName.trim())}
            style={{
              backgroundColor: '#4d4d4d',
              color: '#ffffff',
              opacity: saveLoadingLevel3 ? 0.6 : 1,
              transform: hovered === "dialogLevel3Save" ? "scale(1.07)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogLevel3Save")}
            onMouseLeave={() => setHovered(null)}
          >
            {saveLoadingLevel3 ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New Brand Dialog */}
      <Dialog
        open={addNewBrandDialogOpen}
        onClose={() => setAddNewBrandDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: 0,
            backgroundColor: '#ffffff',
          },
        }}
      >
        <DialogTitle className="UI-title-subTitle" style={{ padding: '16px 24px 0 24px' }}>
          Add New Brand
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          <div className="UI-form-section">
            <div className="UI-form-group">
              <label className="UI-label">Brand Name *</label>
              <input
                type="text"
                value={newBrandName}
                onChange={(e) => {
                  setNewBrandName(e.target.value);
                  setAddNewMessageBrand("");
                }}
                className={`UI-input ${addNewMessageBrand ? 'UI-input-error' : ''}`}
                placeholder="Enter brand name"
                autoFocus
                style={styles.input}
              />
              {addNewMessageBrand && (
                <div className="UI-error-text">{addNewMessageBrand}</div>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setAddNewBrandDialogOpen(false)}
            disabled={saveLoadingBrand}
            style={{
              backgroundColor: hovered === "dialogBrandCancel" ? "#4d4d4d" : '#ffffff',
              color: hovered === "dialogBrandCancel" ? "#fff" : "#4d4d4d",
              transform: hovered === "dialogBrandCancel" ? "scale(1.03)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #4d4d4d',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogBrandCancel")}
            onMouseLeave={() => setHovered(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={submitNewBrand}
            disabled={saveLoadingBrand || !(newBrandName && newBrandName.trim())}
            style={{
              backgroundColor: '#4d4d4d',
              color: '#ffffff',
              opacity: saveLoadingBrand ? 0.6 : 1,
              transform: hovered === "dialogBrandSave" ? "scale(1.07)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogBrandSave")}
            onMouseLeave={() => setHovered(null)}
          >
            {saveLoadingBrand ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New UOM Dialog */}
      <Dialog
        open={addNewUomDialogOpen}
        onClose={() => setAddNewUomDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
            padding: 0,
            backgroundColor: '#ffffff',
          },
        }}
      >
        <DialogTitle className="UI-title-subTitle" style={{ padding: '16px 24px 0 24px' }}>
          Add New UOM
        </DialogTitle>
        <DialogContent style={{ paddingTop: 0 }}>
          <div className="UI-form-section">
            <div className="UI-form-group">
              <label className="UI-label">UOM Name *</label>
              <input
                type="text"
                value={newUomName}
                onChange={(e) => {
                  setNewUomName(e.target.value);
                  setAddNewMessageUom("");
                }}
                className={`UI-input ${addNewMessageUom ? 'UI-input-error' : ''}`}
                placeholder="Enter UOM name (e.g., Kg, Pcs)"
                autoFocus
                style={styles.input}
              />
              {addNewMessageUom && (
                <div className="UI-error-text">{addNewMessageUom}</div>
              )}
            </div>
            <div className="UI-form-group">
              <label className="UI-label">Description (optional)</label>
              <input
                type="text"
                value={newUomDescription}
                onChange={(e) => setNewUomDescription(e.target.value)}
                className="UI-input"
                placeholder="Enter UOM description"
                style={styles.input}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setAddNewUomDialogOpen(false)}
            disabled={saveLoadingUom}
            style={{
              backgroundColor: hovered === "dialogUomCancel" ? "#4d4d4d" : '#ffffff',
              color: hovered === "dialogUomCancel" ? "#fff" : "#4d4d4d",
              transform: hovered === "dialogUomCancel" ? "scale(1.03)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: '1px solid #4d4d4d',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogUomCancel")}
            onMouseLeave={() => setHovered(null)}
          >
            Cancel
          </Button>
          <Button
            onClick={submitNewUom}
            disabled={saveLoadingUom || !(newUomName && newUomName.trim())}
            style={{
              backgroundColor: '#4d4d4d',
              color: '#ffffff',
              opacity: saveLoadingUom ? 0.6 : 1,
              transform: hovered === "dialogUomSave" ? "scale(1.07)" : "scale(1)",
              transition: "all 0.01s ease",
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 12px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '0.8rem',
              fontWeight: 500,
              cursor: 'pointer',
              minHeight: '32px',
              minWidth: 100,
            }}
            onMouseEnter={() => setHovered("dialogUomSave")}
            onMouseLeave={() => setHovered(null)}
          >
            {saveLoadingUom ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(NewServices);